var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.029 512.029",
    style: {
      enableBackground: "new 0 0 512.029 512.029"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.121,133.455l-112-128c-2.496-2.752-5.856-4.192-9.312-4.832L105.177,320.015h310.784v-73.28l4.8,4.48    c3.2,3.52,8.32,5.12,12.8,4.8c4.8-0.64,8.96-3.2,11.84-7.04l64-96C513.241,146.895,512.921,138.895,508.121,133.455z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M287.961,352.015l28.8,38.4c5.28,7.072,3.84,17.088-3.232,22.4c-2.848,2.176-6.24,3.2-9.568,3.2    c-4.832,0-9.664-2.208-12.8-6.4l-35.2-46.944l-35.2,46.944c-3.136,4.192-7.936,6.4-12.8,6.4c-3.36,0-6.72-1.024-9.6-3.2    c-7.072-5.312-8.512-15.328-3.2-22.4l28.8-38.4h-128v144c0,8.96,7.04,16,16,16h288c8.96,0,16-7.04,16-16v-144H287.961z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "165.529,0.015 249.561,107.887 344.697,0.015   ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.025,132.303L125.401,0.559c-3.584,0.608-7.04,2.048-9.6,4.896l-112,128c-4.48,5.44-5.12,13.44-1.28,19.52l64,96    c2.88,3.84,7.04,6.4,11.84,7.04c4.8,0.32,9.6-1.28,12.8-4.8l4.8-4.48v35.328L228.025,132.303z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaIconWhite);
export default __webpack_public_path__ + "static/media/ma_icon_white.7955d4715bd60eb4ba1f7365f9f5b738.svg";
export { ForwardRef as ReactComponent };